import * as types from '../actions';

export default function setIsLoadingCenterline(isLoadingCenterline) {
  return {
    type: types.VIEWER_SET_IS_LOADING_CENTERLINE,
    isLoadingCenterline,
  };
}
